var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#F5F8FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#A1A3A7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 16.8333C16.4599 16.8333 16.833 16.4602 16.833 16C16.833 15.5397 16.4599 15.1666 15.9997 15.1666C15.5394 15.1666 15.1663 15.5397 15.1663 16C15.1663 16.4602 15.5394 16.8333 15.9997 16.8333Z",
    stroke: "#444CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.833 16.8333C22.2932 16.8333 22.6663 16.4602 22.6663 16C22.6663 15.5397 22.2932 15.1666 21.833 15.1666C21.3728 15.1666 20.9997 15.5397 20.9997 16C20.9997 16.4602 21.3728 16.8333 21.833 16.8333Z",
    stroke: "#444CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1663 16.8333C10.6266 16.8333 10.9997 16.4602 10.9997 16C10.9997 15.5397 10.6266 15.1666 10.1663 15.1666C9.7061 15.1666 9.33301 15.5397 9.33301 16C9.33301 16.4602 9.7061 16.8333 10.1663 16.8333Z",
    stroke: "#444CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more_icon.6da219f475296cb923452636f98de36d.svg";
export { ForwardRef as ReactComponent };